import { render, staticRenderFns } from "./Comparisons.vue?vue&type=template&id=c8287c24&"
import script from "./Comparisons.vue?vue&type=script&lang=js&"
export * from "./Comparisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8287c24')) {
      api.createRecord('c8287c24', component.options)
    } else {
      api.reload('c8287c24', component.options)
    }
    module.hot.accept("./Comparisons.vue?vue&type=template&id=c8287c24&", function () {
      api.rerender('c8287c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/Comparisons.vue"
export default component.exports